import { PayloadAction } from '@reduxjs/toolkit';
import { Criteria, LocalsType } from 'types';

export const ACTION_TYPES = {
  UPDATE_LOCALS: 'UPDATE_LOCALS',
  CREATE_LOCALS: 'CREATE_LOCALS',
};

const localsReducer = (
  state = {} as LocalsType,
  action: PayloadAction<{ key: string; value: any }>
) => {
  const { payload } = action;
  switch (action.type) {
    case ACTION_TYPES.UPDATE_LOCALS:
    case ACTION_TYPES.CREATE_LOCALS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    default:
      return state;
  }
};
export default localsReducer;
